<template>
  <div class="image-picker">
    <picture-input
      ref="pictureInput"
      @change="handleChange"
      :hideChangeButton="true"
      width="600"
      height="400"
    />
    <UpgradeNotification v-if="!isProUser && notifyFreeUsers">
      <UpgradeNotificationContent
        @upgrade="upgrade"
        title="Upload your logo here to preview it in the deck editor"
        intent="display it in live events"
      />
    </UpgradeNotification>
    <div class="buttons">
      <div v-if="value" @click="removeImage" class="button is-dark">Remove Current Image</div>
      <div v-if="slideOptions && slideOptions.imagePlacement" @click="switchPosition()" class="button is-dark">
        Switch
        Image Position <i class="fas fa-random m-l-10" />
      </div>
      <div v-if="hasImage" @click="uploadImage" class="button is-primary">
        Save Image <span v-if="uploadProgress > 0">({{ uploadProgress }}%)</span>
      </div>
    </div>
  </div>
</template>

<script>
// import nhost from 'nhost-js-sdk'
import PictureInput from '~/components/PictureInput'
import { insertFile } from '~/queries/fileQueries.gql'
import UpgradeNotificationContent from '~/components/upgrade/UpgradeNotificationContent'
import UpgradeNotification from '~/components/upgrade/UpgradeNotification'

export default {
  components: { UpgradeNotification, UpgradeNotificationContent, PictureInput },
  props: ['objectPath', 'slideOptions', 'value', 'notifyFreeUsers'],
  data () {
    return {
      status: 'ready',
      uploadProgress: 0,
      hasImage: false
    }
  },
  computed: {
    isProUser () {
      return this.$store.getters.isProUser
    }
  },
  methods: {
    handleChange (event) {
      this.hasImage = true
    },
    switchPosition () {
      this.slideOptions.imagePlacement = this.slideOptions.imagePlacement === 'top' ? 'bottom' : 'top'
      this.$emit('close')
    },
    removeImage () {
      const data = {
        objectPath: this.objectPath,
        downloadUrl: ''
      }

      // update url on slide
      try {
        this.$emit('updateImg', data)
      } catch (e) {
        console.log(e)
      }
      this.$emit('close')
    },
    async uploadImage () {
      this.status = 'uploading'

      const file = this.$refs.pictureInput.file
      const deckId = this.$route.params.id
      let name = Math.floor(Date.now()) + '-' + file.name
      name = encodeURI(name.replace(/\s+/g, '-'))
      const path = `/public/deck-${deckId}/${name}`

      const { metadata, downloadUrl } = await this.$storage.put(path, file, this.onUploadProgress)
      const slideDeck = this.$store.state.currentSlideDeck || {}
      // insert file into DB
      await this.$apollo.mutate({
        mutation: insertFile,
        variables: {
          path,
          url: downloadUrl,
          userId: this.$auth.user.id,
          deckId: slideDeck?.id || null,
          storageId: metadata.id
        }
      })

      const data = {
        objectPath: this.objectPath,
        downloadUrl
      }

      // update url on slide
      try {
        this.$emit('updateImg', data)
      } catch (e) {
        console.log(e)
      }
      this.$emit('close')
    },
    onUploadProgress (data) {
      this.uploadProgress = Math.round((data.loaded / data.total) * 100)
    },
    upgrade () {
      this.$emit('upgrade')
    }
  }
}
</script>

<style lang="scss">
.image-picker {
  background-color: #fafafa;
  border-radius: 4px;
  overflow: hidden;
  padding: 30px;

  .picture-preview {
    background-color: transparent !important;
  }

  .buttons {
    // position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0px auto;
    justify-content: center;
    padding: 20px 0px 0px;
    // background:linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,.2));
    // z-index: 10500; // stupid picture input has crazy high z-level set;
  }
}
</style>
